<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">样本册：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="样本册"
                clearable
                v-model="queryData.sampleName"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">托盘号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="托盘号"
                clearable
                v-model="queryData.PT"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">库名：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="库名"
                clearable
                v-model="queryData.position"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空
            </el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库名"
            prop="position"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="托盘号"
            prop="pt"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库数量"
            prop="instore_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="现有数量"
            prop="current_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-remove"
                circle
                plain
                @click.stop.prevent="moveHandle(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        sampleName: "",
        PT: "",
        position: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getProductPositionList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    // 移库
    moveHandle: function(_row) {
      let _this = this;
      _this
        .$confirm("确定移库？?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.post(_this.$apis.updateProductPosition, _row, function(res) {
            let _json = res.data;
            if (_json.status && _json.status === "logout") {
              _this.logout();
            } else {
              if (_json.status === "ok") {
                _this.$message({
                  type: "success",
                  message: "移库成功！"
                });
                _this.loadData();
              } else {
                _this.$message({
                  type: "error",
                  message: "移库失败！"
                });
              }
            }
          });
        });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.position = "";
        this.queryData.sampleName = "";
        this.queryData.PT = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    }
  },
  components: {}
};
</script>
